import createDragNDropUploadPlugin from '@mikeljames/draft-js-drag-n-drop-upload-plugin';
import { convertToRaw, EditorState } from 'draft-js';
import {
  HeadlineOneButton, HeadlineTwoButton, HeadlineThreeButton, BlockquoteButton, CodeButton,

  BoldButton, ItalicButton,
  OrderedListButton, UnderlineButton,
  UnorderedListButton, createBlockStyleButton
} from 'draft-js-buttons';
import { stateToHTML } from 'draft-js-export-html';
import createFocusPlugin from 'draft-js-focus-plugin';
import createImagePlugin from 'draft-js-image-plugin';
import createAlignmentPlugin from 'draft-js-alignment-plugin';
import { stateFromHTML } from 'draft-js-import-html';
import Editor, { composeDecorators } from 'draft-js-plugins-editor';
import createResizeablePlugin from 'draft-js-resizeable-plugin';
import createToolbarPlugin from 'draft-js-static-toolbar-plugin';
import createVideoPlugin from '@draft-js-plugins/video';
import draftToHtml from 'draftjs-to-html';
import { setBlockData } from 'draftjs-utils';
import React, { Component } from 'react';
import { FontIcon } from 'react-md';
import 'draft-js/dist/Draft.css'; // for placeholder css
import '../../node_modules/draft-js-alignment-plugin/lib/plugin.css';
import '../../node_modules/draft-js-focus-plugin/lib/plugin.css';
import '../../node_modules/draft-js-static-toolbar-plugin/lib/plugin.css';
import '../css/RTEditor.css';
import AddImageButton from './AddImageButton';
import VideoAdd from './VideoAdd';
import { re } from 'mathjs';
import "./TextEditor.css";
import math from 'mathjs';
import { NotificationManager } from 'react-notifications';
import "./textEditorStyle.css"


// 1. Define the custom Headline 4, 5, and 6 buttons
const HeadlineFourButton = createBlockStyleButton({
  blockType: 'header-four',
  children: <span>H4</span>,
});

const HeadlineFiveButton = createBlockStyleButton({
  blockType: 'header-five',
  children: <span>H5</span>,
});

const HeadlineSixButton = createBlockStyleButton({
  blockType: 'header-six',
  children: <span>H6</span>,
});



const styleMap = {
  'ALIGN_CENTER': {
    textAlign: 'center',
  },
  'ALIGN_RIGHT': {
    textAlign: 'right',
  },
  'ALIGN_LEFT': {
    textAlign: 'left',
  },
};


let customBlockStyleFn  = function(contentBlock) {
  const type = contentBlock.getType();

  if (type === 'unstyled') {

      const data  = contentBlock.getData();
      if( data.includes('ALIGN_CENTER'))
        return 'centerAlignBlock';
      if(data.includes('ALIGN_RIGHT'))
        return 'rightAlignBlock';
      if(data.includes('ALIGN_LEFT'))
        return 'leftAlignBlock';

  }
}

const blockStyleFn = (block) => {
  const alignment = block.getData().get('alignment');
  console.debug("alignment>>??", alignment, block.getData())
  switch (alignment) {
    case 'left':
      return 'align-left clearfix';
    case 'center':
      return 'align-center clearfix';
    case 'right':
      return 'align-right clearfix';
    default:
      return 'clearfix';
  }
};

let options = {
  // blockRenderers: {
  //   unstyled: (block) => {
  //     let data = block.getData();

  //     let blockText = block.getText();
  //     if(blockText.trim() === '') //bug-tracker#264
  //       return '';
  //     let style = '';
  //     if( data.includes('ALIGN_CENTER'))
  //       style = "style='text-align:center;'"
  //     if(data.includes('ALIGN_RIGHT'))
  //       style = "style='text-align:right;'"
  //     if(data.includes('ALIGN_LEFT'))
  //       style = "style='text-align:left;'"
  //     return '<p '+style+'>' + blockText + '</p>'
  //   },
  // }, 
  blockStyleFn : (block) => {
    let data = block.getData();
    if (data.size == 0) return;

    let style = {};
    if (data.get('text-align')) style = { ...style, textAlign: data.get('text-align') }
    return  {
      attributes: {
        dir: 'auto'
      },
      style
    };
  },
  entityStyleFn: (entity) => {
    const entityType = entity.get('type').toLowerCase();
    //console.log("entityType",entityType);

    if (entityType === 'image') {
      const data = entity.getData();
      ////console.log('image-data',data);
      let computedWidth = data.width;
      if(computedWidth === undefined)
      computedWidth = 30;

      const float = data.alignment || data.float || data.dataVal;

      let style = {}
      let className = ""

      if (float === 'center') {
        className = "custom-image-align-center"
        style = {
          display: 'block',
          marginLeft:'auto',
          marginRight: 'auto',
        }
      } else {
        className = `custom-image-align-${float}`
        if (float) {
          style = {
            float: float
          }
        }
      }

      return {
        element: 'img',
        attributes: {
          src: data.src,
          className: className,
        },
        style: {
          // width: computedWidth+'%',
          ...style,
        },
      };
    }
     if (entityType === 'draft-js-video-plugin-video') {
      const data = entity.getData();
      ////console.log('image-data',data);
      let computedWidth = data.width;
      if(computedWidth === undefined)
      computedWidth = 30;
      return {
        element: 'iframe',
        attributes: {
          src: data.src,
          width: 420,
          height: 315,
          // allow:"fullscreen",
          allowfullscreen: '',
        }
      };
    } 
  },
};

let StringExtract = function(stringInp,prefix, suffix) {
  if(stringInp === undefined || stringInp === null || stringInp.length < 1)
    return stringInp;
  let s = stringInp;
	var i = s.indexOf(prefix);
	if (i >= 0) {
		s = s.substring(i + prefix.length);
	}
	else {
		return '';
	}
	if (suffix) {
		i = s.indexOf(suffix);
		if (i >= 0) {
			s = s.substring(0, i);
		}
		else {
		  return '';
		}
	}
	return s;
};
const videoPlugin = createVideoPlugin();
const { types } = videoPlugin;
let optionsHTML = {
  // Should return a Style() or Entity() or null/undefined
  customInlineFn: (element, {Style, Entity}) => {
    
    if (element.tagName === 'IMG') {
      ////console.log('image-data',element);
      let styleString = element.getAttribute('style');
      let widthValue =  StringExtract(styleString,"width:","%");

      /* if(widthValue === null || widthValue === undefined || isNaN(widthValue))
      {
        widthValue  = '30';
      }
      console.log('element>>??', element); */
      
      let alignment = null;
      if (styleString && styleString.includes('margin-left: auto') && styleString.includes('margin-right: auto')) {
        alignment = 'center';
      } else if (styleString && styleString.includes('float: right')) {
        alignment = 'right';
      } else if (styleString && styleString.includes('float: left')) {
        alignment = 'left';
      }

      // Fallback: check class attribute
      if (alignment === null) {
        let className = element.getAttribute('class') || '';
        if (className.includes('custom-image-align-default')) {
          alignment = 'left';
        } else if (className.includes('custom-image-align-left')) {
          alignment = 'left';
        } else if (className.includes('custom-image-align-right')) {
          alignment = 'right';
        } else if (className.includes('custom-image-align-center')) {
          alignment = 'center';
        } else {
          alignment = 'center';
        }
      }

      return Entity('IMAGE', {src: element.getAttribute('src'),width:widthValue, alignment: alignment},'IMMUTABLE');
    }
    if (element.tagName === 'IFRAME') {
      const {outerHTML} = element;
      const srcPath = outerHTML.match(/src\=([^\s]*)\s/)[1];
      return Entity(types.VIDEOTYPE, {src: srcPath.replace(/['"]+/g, '')},'IMMUTABLE');
    }

  },customBlockFn: (element) => {
    if (element.tagName === 'P') {
      let styleString = element.getAttribute('style');
      let alignmentValue =  StringExtract(styleString,"text-align:",";");
      let dataVal;
      if(alignmentValue !== null || alignmentValue !== undefined ){
        switch(alignmentValue){
          case "center":
            dataVal ='ALIGN_CENTER';
            break;
          case "right":
            dataVal = 'ALIGN_RIGHT';
            break;
          case "left":
            dataVal ='ALIGN_LEFT';
            break;
          default:
            dataVal ='ALIGN_LEFT';
            break;

        }
      }


      return {type: 'unstyled',data:{dataVal}};
    }
  }

};

const createTextAlignControl = ({ blockProps, fontIcon }) => (
  class TextAlignControl extends React.Component {

    constructor(props)
    {
        super(props);
        this.onClick =    this.onClick.bind(this);
        this.inputID  = 'TextAlignControl-'+Math.random().toString();

    }

    onClick = (event) => {
      const { setEditorState, getEditorState } = this.props;
      let editorState  =  getEditorState();
      var selectionState = editorState.getSelection();
      var anchorKey = selectionState.getAnchorKey();
      var currentContent = editorState.getCurrentContent();
      var currentContentBlock = currentContent.getBlockForKey(anchorKey);
      if(currentContentBlock.getType() === 'unstyled')
      {
        let newEditorState  = setBlockData(editorState,{blockProps})
        setEditorState(newEditorState);
      }

    }
    render() {

      return (
        <div className='draftJsToolbar__buttonWrapper__1Dmqh' style={{background:'#fbfbfb'}}>
            <button  flat="true" className='draftJsToolbar__button__qi1gf' onClick={this.onClick.bind(this)} >
              <FontIcon  >{fontIcon}</FontIcon>
          </button>

        </div>
      );
    }
  }
);

export default class TextEditor extends Component {

    constructor(props)
    {
      super(props);

      this.state = {
        editorState: EditorState.createEmpty(),
      }

      // Creates an Instance. At this step, a configuration object can be passed in
        // as an argument.
        this.focusPlugin = createFocusPlugin();
        this.resizeablePlugin = createResizeablePlugin();
        //const alignmentPlugin = createAlignmentPlugin();
        //const { AlignmentTool } = alignmentPlugin;
        this.alignmentPlugin = createAlignmentPlugin();
        // const { AlignmentTool } = this.alignmentPlugin;
        // this.AlignmentTool = AlignmentTool;

        this.decorator = composeDecorators(
          this.resizeablePlugin.decorator,
          this.focusPlugin.decorator,
          this.alignmentPlugin.decorator,
          //alignmentPlugin.decorator
        );




        let decorator = this.decorator;
        this.imagePlugin = createImagePlugin({ decorator });

        this.dragNDropFileUploadPlugin = createDragNDropUploadPlugin({
          handleUpload: this._uploadImageCallBack,
          addImage: this.imagePlugin.addImage,
        });
        
        this.toolbarPlugin = createToolbarPlugin({
          structure: [
            HeadlineOneButton, HeadlineTwoButton, HeadlineThreeButton, HeadlineFourButton, HeadlineFiveButton, HeadlineSixButton,
            BlockquoteButton,
            BoldButton,
            ItalicButton,
            UnderlineButton,
            UnorderedListButton,
            OrderedListButton,
            CodeButton
            /* createTextAlignControl({
              blockProps:'ALIGN_LEFT',
              fontIcon: 'format_align_left',
            }),
            createTextAlignControl({
              blockProps:'ALIGN_CENTER',
              fontIcon: 'format_align_center',
            }),
            createTextAlignControl({
              blockProps:'ALIGN_RIGHT',
              fontIcon: 'format_align_right',
            }) */
          ]
        });

        this.plugins = [this.toolbarPlugin,this.focusPlugin,this.resizeablePlugin,this.imagePlugin,this.dragNDropFileUploadPlugin, this.alignmentPlugin];

        this.plugins.push(videoPlugin);
          

        this.getEditorStateLocal = this.getEditorStateLocal.bind(this);
        this.setEditorStateLocal = this.setEditorStateLocal.bind(this);
        this.fixCursorBug = this.fixCursorBug.bind(this);
    }



    _uploadImageCallBack  = (file) =>{

      const imageObject = {
        file: file,
        localSrc: URL.createObjectURL(file),
      }

      return new Promise(
        (resolve, reject) => {
          resolve({ data: { link: imageObject.localSrc } });
        }
      );
    }

    fixCursorBug(prevEditorState, nextEditorState) {
      const prevSelection = prevEditorState.getSelection();
      const nextSelection = nextEditorState.getSelection();
      if (
          prevSelection.getAnchorKey() === nextSelection.getAnchorKey()
          && prevSelection.getAnchorOffset() === 0
          && nextSelection.getAnchorOffset() === 1
          && prevSelection.getFocusKey() === nextSelection.getFocusKey()
          && prevSelection.getFocusOffset() === 0
          && nextSelection.getFocusOffset() === 1
          && prevSelection.getHasFocus() === false
          && nextSelection.getHasFocus() === false
      ) {
          const fixedSelection = nextSelection.merge({ hasFocus: true });
          return EditorState.forceSelection(nextEditorState, fixedSelection);
      }
      return nextEditorState;
    }

    componentDidMount() {
      if (this.props.value) {
          this.setState({
            editorState: this.props.value
          })
      }
    }

    /* componentDidUpdate(prevProps, prevState) {
      if (prevProps.value && this.props.value && prevProps.value.getCurrentContent() !== this.props.value.getCurrentContent()) {
            this.setState({
              editorState: this.props.value
            })
      }

      if (prevState.editorState.getCurrentContent() !== this.state.editorState.getCurrentContent()) {
        this.props.onChange(this.state.editorState);
      }
    } */

    componentDidUpdate(prevProps, prevState) {
      if (prevProps.value !== this.props.value) {
        this.setState({ editorState: this.props.value });
      }

      if (prevState.editorState !== this.state.editorState) {
        this.props.onChange(this.state.editorState);
      }
    }

    onChange = (editorState) => {
      // console.debug("<<<<onChange CALLED>>>>>>>>")
        // const nextEditorState = this.fixCursorBug(this.props.value, editorState);
        // this.props.onChange(nextEditorState);
        this.setState({
          editorState: editorState,
        })
    };

    handlePastedText = (text, html) => {
      if (html && html.includes('<img')) {
        NotificationManager.error(
          "Pasting content with images is not allowed. Please upload the image separately.",
          "Paste Blocked"
        );
        return 'handled';
      }
      return 'not-handled';
    };

    focus = () => {
        this.editor.focus();
    };

    toString()
    {
      return draftToHtml(convertToRaw(this.props.value.getCurrentContent()));
    }
    //Static Helpers

    static getHTMLStringFromEditorState = function(editorState){
        ////console.log('editorState',JSON.stringify(convertToRaw(editorState.getCurrentContent())));
        let text = stateToHTML(editorState.getCurrentContent(),options);
        text = text.replaceAll("&nbsp;", "");
        // text = text.replaceAll("<figure>", "");
        // text = text.replaceAll("</figure>", "");
        
        return text;
    }

    static replaceVectorVars(html, vectorVariableMap) {
      if (vectorVariableMap === null || vectorVariableMap === undefined) return html
        return html.replace(
            /\\eval\{(\\vec\{[^}]+\})_(x|y|z|mag|magnitude|angle|ang)\}/g,
            (match, vecName, prop) => {
                const vec = vectorVariableMap.get(vecName);
                if (!vec) return match;
                if (!(prop in vec)) return match;

                return vec[prop];
            }
        );
    }

    static replaceRPVariableVars(html, variablesMap) {
        return html.replace(
            /\\eval\{([^}]+)\}/g,
            (match, varName) => {
                const key = `[${varName}]`;
                for (const [mapKey, obj] of variablesMap) {
                    if (mapKey === key && obj) {
                      return obj.value
                    };
                }
                return match;
            }
        );
    }

    static doRPCalculations(html) {
      if (!html) return html;

      return html.replace(/{{(.*?)}}/g, (match, expr) => {
        try {
          const result = math.eval(expr.trim());
          return result;
        } catch (err) {
          return match; // fallback: keep original if error
        }
      });
    }

    static getHTMLStringFromEditorStateWithoutFigure = function(editorState, vectorVariableMap, variablesMap){
        let text = stateToHTML(editorState.getCurrentContent(),options);

        if (vectorVariableMap) {
          text = this.replaceVectorVars(text, vectorVariableMap)
        }
        if (variablesMap) {
          text = this.replaceRPVariableVars(text, variablesMap)
          text =  this.doRPCalculations(text)
        }

        text = text.replaceAll("<figure>", "");
        text = text.replaceAll("</figure>", "");
        text = text.replaceAll("&nbsp;", "");
        return text;
    }


    static createVideoLinkIframe    =   function(htmlString , isQestionListPreview){
      // Since we are not santizing the iframe, we dont need this so we are returning null
      return null;
      const _html = htmlString.trim();
      if(_html){
        const regexResult = _html.match(/<iframe ?.* src="([^"]+)" ?.*>/);
        if(regexResult){
          let srcPath = regexResult[1];
          const url = new URL(srcPath);

          // add required query parameters to remove yt recommendations if they are missing
          if (!url.searchParams.has('rel')) {
            url.searchParams.set('rel', '0');
          }
          if (!url.searchParams.has('showinfo')) {
            url.searchParams.set('showinfo', '0');
          }
          
          srcPath = url.toString()
          return <iframe src={`${srcPath.trim().replace(/['"]+/g, '')}`} width={isQestionListPreview? '100%' : 420} height={isQestionListPreview?  '100%' :315} title="video-question" />
        }
        return null;
      }else{
        return null;
      }
    } 

    static createValueFromString = function(htmlString)
    {
        if(htmlString === '' || htmlString === undefined)
          return EditorState.createEmpty();
        /* const blocksFromHTML = convertFromHTML(htmlString);


        const state = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
        );
        //console.log('ContentState',JSON.stringify(state)); */

        return EditorState.createWithContent(stateFromHTML(htmlString,optionsHTML));
    }

    static createEmptyValue    =   function()
    {
        return EditorState.createEmpty();
    }

    getEditorStateLocal()
    {


      return this.props.value;
    }

    setEditorStateLocal(editorState)
    {
      this.onChange(editorState);
    }

    render() {
      let { Toolbar } = this.toolbarPlugin;
      let { AlignmentTool } = this.alignmentPlugin;

        return(
            <div className={'RTWrapper' + " text-editor-container custom-text-editor"}>

                  <div className='RT-ToolBar-Wrapper'>
                    <Toolbar className='TextEditorToolbar' />
                    <AddImageButton getEditorState={this.getEditorStateLocal}
                                    setEditorState={this.setEditorStateLocal}/>
                     <VideoAdd
                      editorState={this.props.value}
                      onChange={this.onChange}
                      modifier={videoPlugin.addVideo}
                    />

                  </div>

                <Editor
                spellCheck={true}
                editorState={this.state.editorState}
                onChange={this.onChange}
                handlePastedText={this.handlePastedText}
                plugins={this.plugins}
                key='editorKey'
                placeholder={this.props.placeholder ? this.props.placeholder : ''}
                //customStyleMap={styleMap}
                // blockStyleFn={customBlockStyleFn}
                // blockStyleFn={blockStyleFn}
                />
                <AlignmentTool/>
            </div>
        );
    }
}
